import { useEffect, useState, useCallback } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  where
} from 'firebase/firestore';
import { db } from '../firebase';
import './App.css';

function Notes() {
  const [user, setUser] = useState(null);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [editingNoteId, setEditingNoteId] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(), u => {
      if (u) setUser(u);
    });
    return () => unsubscribe();
  }, []);

  const fetchNotes = useCallback(async () => {
    if (!user) return;
    const q = query(collection(db, 'notes'), where('uid', '==', user.uid));
    const querySnapshot = await getDocs(q);
    const userNotes = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    setNotes(userNotes);
  }, [user]);

  useEffect(() => {
    if (user) fetchNotes();
  }, [user, fetchNotes]);

  const createNote = async () => {
    if (!newNote.trim()) return;
    const docRef = await addDoc(collection(db, 'notes'), {
      uid: user.uid,
      content: newNote,
      createdAt: Date.now(),
    });
    setNotes([...notes, { id: docRef.id, content: newNote }]);
    setNewNote('');
  };

  const updateNote = async (id, content) => {
    const noteRef = doc(db, 'notes', id);
    await updateDoc(noteRef, { content });
    setNotes(notes.map(note => (note.id === id ? { ...note, content } : note)));
    setEditingNoteId(null);
  };

  const deleteNote = async id => {
    await deleteDoc(doc(db, 'notes', id));
    setNotes(notes.filter(note => note.id !== id));
  };

  return (
    <div className="note-page">
      <div className="new-note">
        <textarea
          placeholder="Write a new note..."
          value={newNote}
          onChange={e => setNewNote(e.target.value)}
        />
        <button onClick={createNote}>+ Add Note</button>
      </div>

      <div className="notes">
        {notes.map(note => (
          <div key={note.id} className="note-card">
            {editingNoteId === note.id ? (
              <>
                <textarea
                  value={note.content}
                  onChange={e =>
                    setNotes(notes.map(n =>
                      n.id === note.id ? { ...n, content: e.target.value } : n
                    ))
                  }
                />
                <div className="actions">
                  <button onClick={() => updateNote(note.id, note.content)}>Save</button>
                  <button onClick={() => setEditingNoteId(null)}>Close Note Editor</button>
                </div>
              </>
            ) : (
              <>
                <p>{note.content}</p>
                <div className="actions">
                  <button onClick={() => setEditingNoteId(note.id)}>Edit</button>
                  <button onClick={() => deleteNote(note.id)}>Delete</button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Notes;
